import React, { useEffect } from 'react'

const Contacts = () => {
  useEffect(() => {
    window.scroll(0,0)


}, [])
  return (
    <div className="flex items-center justify-center">
      Contacts
    </div>
  )
}

export default Contacts
